var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptopPrinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.658,
    height: 76.461,
    viewBox: "0 0 168.658 76.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5327",
    "data-name": "Group 5327",
    transform: "translate(-32.156 -57.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(32.156 76.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5285",
    "data-name": "Group 5285",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8986",
    "data-name": "Path 8986",
    d: "M83.185,129.446H79.311V89.266c0-2.739-2.452-4.682-5.413-4.682H9.922c-2.963,0-5.334,1.942-5.334,4.682v40.18H.633c-.362,0-.633-.031-.633.3v.565a5.973,5.973,0,0,0,5.934,5.8H77.882a6.045,6.045,0,0,0,6.016-5.8v-.565C83.9,129.415,83.547,129.446,83.185,129.446Zm-42.2-43a1.422,1.422,0,0,1,1.848,0,1.159,1.159,0,0,1,.387.855,1.172,1.172,0,0,1-.387.86,1.391,1.391,0,0,1-1.848,0,1.17,1.17,0,0,1-.387-.86A1.15,1.15,0,0,1,40.985,86.447Zm34.392,40.574H8.521V90.041H75.377Z",
    transform: "translate(0 -84.584)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "printer",
    transform: "translate(117.921 57.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5287",
    "data-name": "Group 5287",
    transform: "translate(18.712 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5286",
    "data-name": "Group 5286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8987",
    "data-name": "Path 8987",
    d: "M159.814.691H116.808a1.188,1.188,0,0,0-1.231,1.139V23.871a1.235,1.235,0,0,0,2.462,0V2.968h40.544v20.9a1.235,1.235,0,0,0,2.462,0V1.83A1.188,1.188,0,0,0,159.814.691Z",
    transform: "translate(-115.577 -0.691)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5289",
    "data-name": "Group 5289",
    transform: "translate(17.159 48.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5288",
    "data-name": "Group 5288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8988",
    "data-name": "Path 8988",
    d: "M151.654,327.4h1.674a1.142,1.142,0,1,0,0-2.277H107.215a1.142,1.142,0,1,0,0,2.277h1.674l-2.068,17.839a1.164,1.164,0,0,0,1.093,1.253,1.209,1.209,0,0,0,1.355-1.011l2.1-18.082h37.812l2.7,23.325H108.661l.167-1.442a1.164,1.164,0,0,0-1.093-1.253,1.213,1.213,0,0,0-1.355,1.011l-.313,2.7a1.085,1.085,0,0,0,.308.883,1.278,1.278,0,0,0,.916.378h45.962a1.278,1.278,0,0,0,.916-.378,1.085,1.085,0,0,0,.308-.883Z",
    transform: "translate(-105.984 -325.127)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5291",
    "data-name": "Group 5291",
    transform: "translate(0 25.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5290",
    "data-name": "Group 5290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8989",
    "data-name": "Path 8989",
    d: "M68.2,171.663H8.02c-4.422,0-8.02,3.328-8.02,7.418v25.381c0,4.09,3.6,7.418,8.02,7.418h7.575a1.142,1.142,0,1,0,0-2.277H8.02a5.367,5.367,0,0,1-5.558-5.141V179.081A5.367,5.367,0,0,1,8.02,173.94H68.2a1.142,1.142,0,1,0,0-2.277Z",
    transform: "translate(0 -171.663)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5293",
    "data-name": "Group 5293",
    transform: "translate(66.065 25.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5292",
    "data-name": "Group 5292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8990",
    "data-name": "Path 8990",
    d: "M416.867,171.663H414.3a1.142,1.142,0,1,0,0,2.277h2.565a5.368,5.368,0,0,1,5.559,5.141v25.381a5.368,5.368,0,0,1-5.559,5.141h-7.575a1.142,1.142,0,1,0,0,2.277h7.575c4.423,0,8.022-3.328,8.022-7.418V179.081C424.889,174.991,421.29,171.663,416.867,171.663Z",
    transform: "translate(-408.061 -171.663)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5295",
    "data-name": "Group 5295",
    transform: "translate(13.296 43.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5294",
    "data-name": "Group 5294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8991",
    "data-name": "Path 8991",
    d: "M137.194,289.271H83.354a1.188,1.188,0,0,0-1.231,1.139v12.145a1.188,1.188,0,0,0,1.231,1.139h2.017a1.142,1.142,0,1,0,0-2.277h-.786v-9.868h51.377v9.868h-.786a1.142,1.142,0,1,0,0,2.277h2.017a1.188,1.188,0,0,0,1.231-1.139V290.41A1.188,1.188,0,0,0,137.194,289.271Z",
    transform: "translate(-82.123 -289.271)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5297",
    "data-name": "Group 5297",
    transform: "translate(5.089 30.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5296",
    "data-name": "Group 5296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8992",
    "data-name": "Path 8992",
    d: "M36.929,203.094a5.1,5.1,0,1,0,0,10.172,5.1,5.1,0,1,0,0-10.172Zm0,7.894a2.817,2.817,0,1,1,3.037-2.809A2.933,2.933,0,0,1,36.929,210.988Z",
    transform: "translate(-31.43 -203.094)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5299",
    "data-name": "Group 5299",
    transform: "translate(17.892 30.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5298",
    "data-name": "Group 5298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8993",
    "data-name": "Path 8993",
    d: "M116.01,203.094a5.1,5.1,0,1,0,5.5,5.086A5.31,5.31,0,0,0,116.01,203.094Zm0,7.894a2.817,2.817,0,1,1,3.037-2.809A2.933,2.933,0,0,1,116.01,210.988Z",
    transform: "translate(-110.511 -203.094)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5301",
    "data-name": "Group 5301",
    transform: "translate(24.211 67.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5300",
    "data-name": "Group 5300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8994",
    "data-name": "Path 8994",
    d: "M182.781,451.489H150.773a1.142,1.142,0,1,0,0,2.277h32.008a1.142,1.142,0,1,0,0-2.277Z",
    transform: "translate(-149.542 -451.489)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5303",
    "data-name": "Group 5303",
    transform: "translate(24.99 62.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5302",
    "data-name": "Group 5302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8995",
    "data-name": "Path 8995",
    d: "M186.036,417.017H155.586a1.142,1.142,0,1,0,0,2.277h30.449a1.142,1.142,0,1,0,0-2.277Z",
    transform: "translate(-154.355 -417.017)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5305",
    "data-name": "Group 5305",
    transform: "translate(25.647 57.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5304",
    "data-name": "Group 5304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8996",
    "data-name": "Path 8996",
    d: "M188.778,382.546H159.642a1.142,1.142,0,1,0,0,2.277h29.136a1.142,1.142,0,1,0,0-2.277Z",
    transform: "translate(-158.411 -382.546)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopPrinter);
export default __webpack_public_path__ + "static/media/laptop-printer.8acf8c28054306e69bee6d2afbe03d91.svg";
export { ForwardRef as ReactComponent };